import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
import Campaign from './../models/Campaign';

const initialState = {
    isFetching: false,
    isFetchingSubData: false,
    isFetchingUpdate: false,
    isFetchingLoad: false,
    campaigns: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    countries: [],
    channels: [],
    banks: [],
    detail: {
        campaign: new Campaign()
    },
    markupConfigs: [],
    markupBundleMinValue: null, 
    markupFlys: [],
    isFetchParseExcel: false,
    emailDetail: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        // List Campaigns
        case Types.CAMPAIGN_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.CAMPAIGN_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                campaigns: action.campaigns.result,
                pageSize: action.campaigns.pageSize,
                pageIndex: action.campaigns.pageIndex,
                totalCount: action.campaigns.totalCount,
                totalPage: Math.ceil(parseInt(action.campaigns.totalCount) / parseInt(action.campaigns.pageSize)),
                ...action.params,
            };
        case Types.CAMPAIGN_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, campaigns: [] };

        case Types.CAMPAIGN_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail, isFetched: false };
        case Types.CAMPAIGN_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                isFetched: true,
                detail: {
                    campaign: action.campaign
                }
            };
        case Types.CAMPAIGN_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.CAMPAIGN_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.CAMPAIGN_UPDATE_SUCCESS:
            return { ...state, isFetching: false };
        case Types.CAMPAIGN_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.CAMPAIGN_CLONE_ACTION:
            return { ...state, isFetching: true};
        // Get all countries
        case Types.CAMPAIGN_LIST_COUNTRIES_ACTION:
            return { ...state, isFetchingSubData: true };
        case Types.CAMPAIGN_LIST_COUNTRIES_SUCCESS:
            return {
                ...state,
                isFetchingSubData: false,
                countries: action.countries.data,
            };
        case Types.CAMPAIGN_LIST_COUNTRIES_FAIL:
            return { ...state, isFetchingSubData: false, countries: [] };

        // Get all channels
        case Types.CAMPAIGN_LIST_CHANNEL_ACTION:
            return { ...state, isFetchingSubData: true };
        case Types.CAMPAIGN_LIST_CHANNEL_SUCCESS:
            return {
                ...state,
                isFetchingSubData: false,
                channels: action.channels.data,
            };
        // get all promotion banks
        case Types.CAMPAIGN_LIST_PROMOTION_BANK_ACTION:
            return { ...state, isFetchingSubData: true };
        case Types.CAMPAIGN_LIST_PROMOTION_BANK_SUCCESS:
            return {
                ...state,
                isFetchingSubData: false,
                banks: action.banks.data,
            };
        case Types.CAMPAIGN_LIST_CHANNEL_FAIL:
            return { ...state, isFetchingSubData: false, channels: [] };

        case Types.CAMPAIGN_FAIL:
            return { ...state, isFetching: false, isFetchingSubData: false, isFetchingUpdate: false, isFetched: false };

        //markup
        case Types.GET_MARKUP_PROMOTION_CONFIG_ACTION:
            return { ...state, isFetching: true };
        case Types.GET_MARKUP_PROMOTION_CONFIG_SUCCESS:
            return {
                ...state,
                isFetching: false,
                markupConfig: action.markups
            };
        case Types.GET_MARKUP_PROMOTION_FLY_ACTION:
            return { ...state, isFetching: true };
        case Types.GET_MARKUP_PROMOTION_FLY_SUCCESS:
            return {
                ...state,
                isFetching: false,
                markupFlys: action.flys
            };
        case Types.GET_MARKUP_BUNDLE_MIN_VALUE_ACTION:
            return { ...state, isFetchingLoad: true };
        case Types.GET_MARKUP_BUNDLE_MIN_VALUE_SUCCESS:
            return {
                ...state,
                isFetchingLoad: false,
                markupBundleMinValue: action.value
            };

        // Parse Excel
        case Types.CAMPAIGN_PARSE_EXCEL_ACTION:
            return { ...state, isFetchParseExcel: true, emailDetail: {} };
        case Types.CAMPAIGN_PARSE_EXCEL_SUCCESS:
            const data = action?.file?.data;
            return {
                ...state,
                isFetchParseExcel: false,
                emailDetail: {
                    data: data?.data,
                    errors: data?.dataErrors,
                    validationError: data?.validationError,
                }
            };
        case Types.CAMPAIGN_PARSE_EXCEL_FAIL:
            return { ...state, isFetchParseExcel: false, emailDetail: {} };
        case Types.CAMPAIGN_PARSE_EXCEL_CLEAR_DATA:
            return { ...state, isFetchParseExcel: false, emailDetail: {} };

        default:
            return state;
    }
}
